import React, { useState, useCallback } from 'react';
import VariationTranscribeModal from 'packages/pages/design/sidebar/variations/VariationTranscribeModal';
import { Variation } from 'packages/pages/design/VariationsContext/types';

type TranscribeModalState = {
    isOpen: boolean;
    variation: Variation | null;
};

const useVariationTranscribeModal = () => {
    const [modalState, setModalState] = useState<TranscribeModalState>({
        isOpen: false,
        variation: null,
    });

    const openTranscribeModal = useCallback((variation: Variation) => {
        setModalState({
            isOpen: true,
            variation,
        });
    }, []);

    const closeTranscribeModal = useCallback(() => {
        setModalState({
            isOpen: false,
            variation: null,
        });
    }, []);

    const handleTranscribe = useCallback(
        (language: string) => {
            // TODO: Implement transcribe API call with modalState.variation and language
        },
        [modalState.variation],
    );

    const renderVariationTranscribeModal = () => (
        <VariationTranscribeModal
            isOpen={modalState.isOpen}
            onClose={closeTranscribeModal}
            variationName={modalState.variation?.name || ''}
            onTranscribe={handleTranscribe}
        />
    );

    return {
        openTranscribeModal,
        renderVariationTranscribeModal,
    };
};

export default useVariationTranscribeModal;
